import AuthenticatedComponent from '../../utilities/AuthenticatedComponent';
import configuration from '../../config.js';
import { useApi } from '../api/useApi';

const authenticatedComponent = new AuthenticatedComponent();

export const useThermalZone = () => {
  const { postData } = useApi();
  // const getControlModes = ({ zoneData, zoneEvents, campusEvents }) => {
  // console.log('Determining control mode with:', { zoneData, zoneEvents, campusEvents });
  // Determine control mode based on zone data and events
  // This is a placeholder implementation and should be replaced with actual logic)
  // };

  const filterActiveZoneEvents = (zoneEvents) => {
    if (!zoneEvents || zoneEvents.length === 0) {
      return [];
    }
    const currentTime = new Date();
    // console.log('currentTime:',  currentTime);
    const activeEvents = zoneEvents.filter((event) => {
      const startTime = new Date(event.startTime);
      const endTime = new Date(event.endTime);
      // console.log('Checking event:', event.name);
      // console.log('startTime:', startTime);
      // console.log('endTime:', endTime);
      return startTime <= currentTime && currentTime <= endTime;
    });
    return activeEvents;
  };

  async function updateThermalZoneSchedule({
    thermalZoneEntityKey,
    scheduleName,
    successCallback,
  }) {
    const url = `${configuration['backend_host']}/ahiapi/${thermalZoneEntityKey}/thermalZone/configuration`;
    if (!scheduleName) {
      console.error('No schedule name provided for updateThermalZoneSchedule');
      return;
    }
    const formData = new FormData();
    formData.append('scheduleName', scheduleName);
    const response = await fetch(`${url}`, {
      method: 'POST',
      headers: authenticatedComponent.generateAuthenticatedHeader(),
      body: formData,
    });
    // if (response.status === 401) { handleUnauthorized(); return null; }
    if (!response.ok) throw new Error('Failed to post data');
    if (successCallback) {
      successCallback();
    }
    // return response;
  }

  const handleLock = ({ lockState, thermalZoneEntityKey, successCallback, failCallback }) => {
    const lockData = new FormData();
    lockData.append('lock', lockState);
    postData({
      url: `${configuration['backend_host']}/ahiapi/${thermalZoneEntityKey}/thermalZone/lockLocalOverride`,
      payload: lockData,
      successCallback: () => {
        successCallback();
      },
      failCallback: failCallback,
    });
  };

  const handleManageOptimized = ({ managedState, thermalZoneEntityKey, successCallback }) => {
    const managedData = new FormData();
    managedData.append('operationsFlag', managedState ? 'normal' : 'uncontrolled');
    postData({
      url: `${configuration['backend_host']}/ahiapi/${thermalZoneEntityKey}/thermalZone/configuration`,
      payload: managedData,
      successCallback: () => {
        successCallback();
      },
      failCallback: () => console.log('Failed to update'),
    });
  };

  const handleCancelOverride = ({ thermalZoneEntityKey, successCallback }) => {
    postData({
      url: `${configuration['backend_host']}/ahiapi/${thermalZoneEntityKey}/thermalZone/override/cancel`,
      payload: null,
      successCallback: () => {
        successCallback();
      },
      failCallback: () => console.log('Failed to cancel override'),
      method: 'GET',
    });
  };

  return {
    // getControlModes,
    filterActiveZoneEvents,
    updateThermalZoneSchedule,
    handleLock,
    handleManageOptimized,
    handleCancelOverride,
  };
};
